import React, { Component, Fragment } from 'react';

// 기타 react
import { connect } from "react-redux";
import compose from "recompose/compose";
import {
    reduxForm, 
    getFormValues,
    getFormSubmitErrors,
    SubmissionError
} from 'redux-form';
import { FormattedMessage } from "react-intl";
import isEmpty from 'lodash-es/isEmpty';
import ReactJson from 'react-json-view';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import FormLabel from "@material-ui/core/FormLabel";
import FormHelperText from "@material-ui/core/FormHelperText";

// custom
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";
import Button from "components/react-template/CustomButtons/Button.jsx";
import ButtonFileUploaderComponent from "components/uploader/ButtonFileUploaderComponent";
import GridContainer from "components/react-template/Grid/GridContainer.jsx";
import GridItem from "components/react-template/Grid/GridItem.jsx";
import CustomInput from "components/react-custom-template/CustomInput/CustomInput.jsx";
import FormField from "components/common/input/FormField";
import { download } from 'util/common';
import { trimLeft } from 'util/form';
import { 
    crudCreateForMultipart as crudCreateForMultipartAction
} from "store/actions/dataActions";
import { 
    showNotification as showNotificationAction
} from 'store/actions/notificationActions';


class DocumentFileDeIdentification extends Component {
    constructor(props) {
        super(props);
        this.state = {
          fileNames: [],
          files: []
        };
    }

    componentWillReceiveProps(nextProps) {
        if( nextProps.refreshVersion !== this.props.refreshVersion ) {
            if( this.props.anyTouched || this.props.dirty ) {
                this.props.reset();
                this.setState({
                    fileNames: [],
                    files: []
                });
                this.props.change("fileNames", []);
            }
        }
    }

    handleSetSelectedFile = (fileNames, files) => {
        console.log("fileNames:", fileNames.split(","))
        console.log("files:", files)
        this.setState({
            fileNames: fileNames.split(","),
            files: files
        });
        this.props.change("fileNames", fileNames);
    };

    // 리렌더링이 불필요한 케이스 정의 
    shouldComponentUpdate(nextProps, nextState){
        if (
            nextProps.result === this.props.result &&
            nextProps.submitting === this.props.submitting &&
            nextProps.valid === this.props.valid &&
            nextProps.submitErrors === this.props.submitErrors &&
            this.state === nextState
        ) {
            console.log("DocumentFileDeIdentification >> shouldComponentUpdate : false");
            return false;
        }
        console.log("DocumentFileDeIdentification >> shouldComponentUpdate : true");
        return true;
    }

    // 저장버튼 클릭
    onSubmit = () => {
        console.log("onSubmit")

        const file = this.state.files[0];
        if( !file ) {
            throw new SubmissionError( {fileNames: <FormattedMessage id="common.file.empty" />} );
        }
        console.log("onSubmit OK")
        let formData = this._makeParams(file);
        this.props.dispatchCrudCreate(this.props.menu, formData);
    };

    _makeParams(file) {
        const { customPattern } = this.props.formValues;

        let formData = new FormData();
        formData.append("file", file);
        if( customPattern ) {
            formData.append("customPattern", customPattern);
        }
        return formData;
    }

    onDownload = () => {
        const downloadUrl = this.props.result.downloadUrl;
        const fileName = this.props.result.fileName;

        if( downloadUrl && fileName ) {
            download(downloadUrl, {}, fileName)
                .catch((error) => {
                    console.error('download - Error :', error.message);
                    this.props.dispatchShowNotification(
                        <FormattedMessage id="common.download.failure"/>,
                        'warning'
                    );
                    return;
                });
        } else {
            this.props.dispatchShowNotification(
                <FormattedMessage id="common.wrong.request"/>,
                'warning'
            );
        } 
    }

    render() {
        const { fileNames, files } = this.state;
        const { 
            classes, color, result, 
            submitting, valid, handleSubmit, submitErrors
        } = this.props;
        const errorMsg = submitErrors["fileNames"];

        return (
            <form autoComplete="off" onSubmit={handleSubmit(this.onSubmit)} noValidate>
                {/* 파일 */}
                <section className="formSection">
                    <div className="formSectionTitle">
                        <FormLabel classes={{ root: "row-label" }} required>
                            <FormattedMessage id="document.file.deIdentification.file" />
                        </FormLabel>
                    </div>
                    <GridContainer>
                        <GridItem xs={12}>
                            <ButtonFileUploaderComponent
                                multiple={false}
                                maxSize={5}
                                accept={[".docx", ".doc", ".pptx", ".ppt", ".xlsx", ".xls", ".hwp", ".pdf"]}
                                setSelectedFile={this.handleSetSelectedFile}
                                fileNames={fileNames.join()}
                            />
                            { errorMsg && <FormHelperText className={classes.labelRootError}>
                                {errorMsg}
                            </FormHelperText> }
                        </GridItem>
                    </GridContainer>
                </section>
                {/* 기본 패턴 */}
                <section className="formSection">
                    <div className="formSectionTitle">
                        <FormLabel classes={{ root: "row-label" }}>
                            <FormattedMessage id="document.file.deIdentification.basic.pattern" />
                        </FormLabel>
                    </div>
                    <GridContainer>
                        <GridItem xs={12} sm={12} lg={8}>
                            <ul>
                                <li><FormattedMessage id="document.file.deIdentification.basic.pattern.01" /></li>
                                <li><FormattedMessage id="document.file.deIdentification.basic.pattern.02" /></li>
                                <li><FormattedMessage id="document.file.deIdentification.basic.pattern.03" /></li>
                                <li><FormattedMessage id="document.file.deIdentification.basic.pattern.04" /></li>
                            </ul>
                        </GridItem>
                    </GridContainer>
                </section>
                {/* 사용자 지정 패턴 */}
                <section className="formSection">
                    <div className="formSectionTitle">
                        <FormLabel classes={{ root: "row-label" }}>
                            <FormattedMessage id="document.file.deIdentification.custom.pattern" />
                        </FormLabel>
                    </div>
                    <GridContainer>
                        <GridItem xs={12} sm={12} lg={8}>
                            <FormField
                                name="customPattern"
                                component={CustomInput}
                                color={color}
                                labelId="document.file.deIdentification.custom.pattern.desc"
                                formControlProps={{ fullWidth: true }}
                                //inputProps={{ inputProps: { maxLength: 20 } }}
                                //validate={[required, minLength3]}
                                normalize={trimLeft}
                            />
                        </GridItem>
                    </GridContainer>
                </section>
                <GridContainer 
                    justify={"center"}
                    alignItems={"center"}>
                    <GridItem>
                        <Button
                            color={color}
                            onClick={this.onSubmit}
                            disabled={submitting || files.length === 0 || !valid}
                        >
                            <FormattedMessage id="document.file.deIdentification.upload" />
                        </Button>
                    </GridItem>
                </GridContainer>

                { !isEmpty(result) && 
                    <Fragment>
                        <section>
                            <ReactJson src={result} theme="monokai" />
                        </section>
                        { result.fileName && (
                            <Button
                                    color={color}
                                    onClick={this.onDownload}
                            >
                                <FormattedMessage id="document.file.deIdentification.download" />
                            </Button>
                        )}
                    </Fragment>
                }
                <input type="submit" style={{ display: "none" }}/>
            </form>

        );
    }
}

export default compose(
    withStyles(customCheckboxRadioSwitch),
    connect(
        ( state, props ) => ({
            result: state.main.item,
            refreshVersion: state.main.refreshVersion,
            formValues: getFormValues(props.form)(state),
            submitErrors: getFormSubmitErrors(props.form)(state),
        }), {
            dispatchCrudCreate: crudCreateForMultipartAction,
            dispatchShowNotification: showNotificationAction
        }
    ),
    reduxForm({
        //enableReinitialize: true
    })
)(DocumentFileDeIdentification);
